import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi } from "./api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await authApi.me();
      setUser(data.user);
    } catch (err) {
      // 401 = guest — the common, expected path (not an error). Log other statuses so
      // real integration issues surface in the console during development.
      if (err?.response?.status && err.response.status !== 401) {
        console.warn("[auth] /auth/me failed:", err.response.status, err.response.data);
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await authApi.logout(); }
    catch (err) { console.warn("[auth] Logout request failed:", err?.message || err); }
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

// Trigger Emergent Managed Google Auth. Store intent so we can resume post-login.
export function startGoogleLogin(intent = null) {
  if (intent) {
    try { sessionStorage.setItem("nobsgs_post_login_intent", JSON.stringify(intent)); }
    catch (err) { console.warn("[auth] sessionStorage blocked — post-login intent not saved:", err?.message || err); }
  }
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
